import { render, staticRenderFns } from "./UserSettingWeighing.vue?vue&type=template&id=39dcd482&scoped=true&"
import script from "./UserSettingWeighing.vue?vue&type=script&lang=js&"
export * from "./UserSettingWeighing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dcd482",
  null
  
)

export default component.exports